<div class="loader">
  <div class="d-flex align-items-center">
    <button class="btn btn-primary" type="button" disabled
      style=" background-color: #8a1739; border: 1px solid #005232; opacity: 1;">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      Loading...
    </button>
  </div>
</div>
